/* tslint:disable */
/* eslint-disable */
/**
 * Challenge Service API
 * API for all challenge service endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ben@xp-lab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Achievement
 */
export interface Achievement {
    /**
     * 
     * @type {boolean}
     * @memberof Achievement
     */
    'persisted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Achievement
     */
    'slug': string;
    /**
     * 
     * @type {boolean}
     * @memberof Achievement
     */
    'isPublic': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Achievement
     */
    'showPercentile': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Achievement
     */
    'showWorkTime': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Achievement
     */
    'showMemberSince': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Achievement
     */
    'showFeedbackExcerpt': boolean;
    /**
     * 
     * @type {string}
     * @memberof Achievement
     */
    'firstPublishedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof Achievement
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Achievement
     */
    'taskName': string;
    /**
     * 
     * @type {number}
     * @memberof Achievement
     */
    'attemptNumber': number;
    /**
     * 
     * @type {number}
     * @memberof Achievement
     */
    'grade': number;
    /**
     * 
     * @type {string}
     * @memberof Achievement
     */
    'submittedAt': string;
    /**
     * 
     * @type {number}
     * @memberof Achievement
     */
    'percentile': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Achievement
     */
    'percentileAvailable': boolean;
    /**
     * 
     * @type {number}
     * @memberof Achievement
     */
    'workTime': number | null;
    /**
     * 
     * @type {string}
     * @memberof Achievement
     */
    'memberSince': string | null;
    /**
     * 
     * @type {string}
     * @memberof Achievement
     */
    'feedbackExcerpt': string | null;
    /**
     * The weapon the learner used for this challenge (workState.chosenWeapon, falling back to the task\'s first allowed weapon)
     * @type {TaskWeaponsOfChoiceEnum}
     * @memberof Achievement
     */
    'weaponOfChoice': TaskWeaponsOfChoiceEnum | null;
    /**
     * Branding of the org this assignment-linked submission belongs to; null for non-assignment submissions
     * @type {AchievementOrganization}
     * @memberof Achievement
     */
    'organization': AchievementOrganization | null;
}


/**
 * 
 * @export
 * @interface AchievementAnalytics
 */
export interface AchievementAnalytics {
    /**
     * 
     * @type {number}
     * @memberof AchievementAnalytics
     */
    'totalViews': number;
    /**
     * 
     * @type {number}
     * @memberof AchievementAnalytics
     */
    'last7Days': number;
    /**
     * 
     * @type {Array<AchievementAnalyticsDailySeriesInner>}
     * @memberof AchievementAnalytics
     */
    'dailySeries': Array<AchievementAnalyticsDailySeriesInner>;
    /**
     * 
     * @type {Array<AchievementAnalyticsDailySeriesInner>}
     * @memberof AchievementAnalytics
     */
    'topSources': Array<AchievementAnalyticsDailySeriesInner>;
}
/**
 * 
 * @export
 * @interface AchievementAnalyticsDailySeriesInner
 */
export interface AchievementAnalyticsDailySeriesInner {
    /**
     * 
     * @type {string}
     * @memberof AchievementAnalyticsDailySeriesInner
     */
    '_id': string;
    /**
     * 
     * @type {number}
     * @memberof AchievementAnalyticsDailySeriesInner
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AchievementOrganization
 */
export interface AchievementOrganization {
    /**
     * 
     * @type {string}
     * @memberof AchievementOrganization
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AchievementOrganization
     */
    'name': string;
    /**
     * The organization\'s wide logo URL (null if the org has no wide logo set)
     * @type {string}
     * @memberof AchievementOrganization
     */
    'logoURL'?: string | null;
}
/**
 * 
 * @export
 * @interface AchievementSettingsPatch
 */
export interface AchievementSettingsPatch {
    /**
     * 
     * @type {boolean}
     * @memberof AchievementSettingsPatch
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AchievementSettingsPatch
     */
    'showPercentile'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AchievementSettingsPatch
     */
    'showWorkTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AchievementSettingsPatch
     */
    'showMemberSince'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AchievementSettingsPatch
     */
    'showFeedbackExcerpt'?: boolean;
}
/**
 * 
 * @export
 * @interface ActiveUsersPoint
 */
export interface ActiveUsersPoint {
    /**
     * UTC calendar day, YYYY-MM-DD
     * @type {string}
     * @memberof ActiveUsersPoint
     */
    'date': string;
    /**
     * Distinct users who saved work that day
     * @type {number}
     * @memberof ActiveUsersPoint
     */
    'dau': number;
    /**
     * Distinct users over the trailing 7 days, inclusive
     * @type {number}
     * @memberof ActiveUsersPoint
     */
    'wau': number;
    /**
     * Distinct users over the trailing 30 days, inclusive
     * @type {number}
     * @memberof ActiveUsersPoint
     */
    'mau': number;
}
/**
 * 
 * @export
 * @interface AdminActiveUsersSeriesRequest
 */
export interface AdminActiveUsersSeriesRequest {
    /**
     * Users to leave out of every count (admins, E2E users)
     * @type {Array<string>}
     * @memberof AdminActiveUsersSeriesRequest
     */
    'excludeUserIds': Array<string>;
}
/**
 * 
 * @export
 * @interface AdminActiveUsersSeriesResponse
 */
export interface AdminActiveUsersSeriesResponse {
    /**
     * 
     * @type {Array<ActiveUsersPoint>}
     * @memberof AdminActiveUsersSeriesResponse
     */
    'series': Array<ActiveUsersPoint>;
}
/**
 * 
 * @export
 * @interface AdminBackfillUserActiveDaysRequest
 */
export interface AdminBackfillUserActiveDaysRequest {
    /**
     * Preview without writing
     * @type {boolean}
     * @memberof AdminBackfillUserActiveDaysRequest
     */
    'trial'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminBackfillUserActiveDaysResponse
 */
export interface AdminBackfillUserActiveDaysResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminBackfillUserActiveDaysResponse
     */
    'success': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminBackfillUserActiveDaysResponse
     */
    'trial': boolean;
    /**
     * 
     * @type {AdminBackfillUserActiveDaysResponseStats}
     * @memberof AdminBackfillUserActiveDaysResponse
     */
    'stats': AdminBackfillUserActiveDaysResponseStats;
}
/**
 * 
 * @export
 * @interface AdminBackfillUserActiveDaysResponseStats
 */
export interface AdminBackfillUserActiveDaysResponseStats {
    /**
     * 
     * @type {number}
     * @memberof AdminBackfillUserActiveDaysResponseStats
     */
    'challengesScanned': number;
    /**
     * 
     * @type {number}
     * @memberof AdminBackfillUserActiveDaysResponseStats
     */
    'distinctUserDays': number;
    /**
     * 
     * @type {number}
     * @memberof AdminBackfillUserActiveDaysResponseStats
     */
    'inserted': number;
    /**
     * 
     * @type {string}
     * @memberof AdminBackfillUserActiveDaysResponseStats
     */
    'firstDay'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminBackfillUserActiveDaysResponseStats
     */
    'lastDay'?: string;
}
/**
 * 
 * @export
 * @interface AdminDeleteUserChallengesRequest
 */
export interface AdminDeleteUserChallengesRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminDeleteUserChallengesRequest
     */
    'userId': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDeleteUserChallengesRequest
     */
    'dryRun': boolean;
}
/**
 * 
 * @export
 * @interface AdminDeleteUserChallengesResponse
 */
export interface AdminDeleteUserChallengesResponse {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof AdminDeleteUserChallengesResponse
     */
    'challenges': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteUserChallengesResponse
     */
    'deletedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteUserChallengesResponse
     */
    'droppedDatabases': number;
}
/**
 * 
 * @export
 * @interface AdminMigrateTaskRequest
 */
export interface AdminMigrateTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminMigrateTaskRequest
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminMigrateTaskRequest
     */
    'sharedDBName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminMigrateTaskRequest
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface AdminMigrateTaskResponse
 */
export interface AdminMigrateTaskResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminMigrateTaskResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminMigrateTaskResponse
     */
    'challengeId'?: string;
    /**
     * 
     * @type {Array<AdminMigrateTaskResponseStepsInner>}
     * @memberof AdminMigrateTaskResponse
     */
    'steps': Array<AdminMigrateTaskResponseStepsInner>;
}
/**
 * 
 * @export
 * @interface AdminMigrateTaskResponseStepsInner
 */
export interface AdminMigrateTaskResponseStepsInner {
    /**
     * 
     * @type {string}
     * @memberof AdminMigrateTaskResponseStepsInner
     */
    'step': string;
    /**
     * 
     * @type {string}
     * @memberof AdminMigrateTaskResponseStepsInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof AdminMigrateTaskResponseStepsInner
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface AvailableAssignment
 */
export interface AvailableAssignment {
    /**
     * The unique identifier for the challenge
     * @type {string}
     * @memberof AvailableAssignment
     */
    'challengeId'?: string;
    /**
     * Slug representing the challenge
     * @type {string}
     * @memberof AvailableAssignment
     */
    'slug'?: string;
    /**
     * The unique identifier for the task
     * @type {string}
     * @memberof AvailableAssignment
     */
    'taskId': string;
    /**
     * URL-friendly identifier from the task
     * @type {string}
     * @memberof AvailableAssignment
     */
    'taskSlug'?: string;
    /**
     * The name of the challenge
     * @type {string}
     * @memberof AvailableAssignment
     */
    'name': string;
    /**
     * The description of the challenge
     * @type {string}
     * @memberof AvailableAssignment
     */
    'description'?: string;
    /**
     * 
     * @type {Array<TaskWeaponsOfChoiceEnum>}
     * @memberof AvailableAssignment
     */
    'allowedWeapons': Array<TaskWeaponsOfChoiceEnum>;
    /**
     * 
     * @type {AvailableChallengeStatusEnum}
     * @memberof AvailableAssignment
     */
    'status': AvailableChallengeStatusEnum;
    /**
     * The teaser of the challenge
     * @type {string}
     * @memberof AvailableAssignment
     */
    'teaser'?: string;
    /**
     * The organization ID of the challenge
     * @type {string}
     * @memberof AvailableAssignment
     */
    'organizationId': string;
    /**
     * The name of the organization of the challenge
     * @type {string}
     * @memberof AvailableAssignment
     */
    'organizationName': string;
    /**
     * The start date of the assignment
     * @type {string}
     * @memberof AvailableAssignment
     */
    'startDate'?: string;
    /**
     * The end date of the assignment
     * @type {string}
     * @memberof AvailableAssignment
     */
    'endDate'?: string;
    /**
     * The overdue date of the assignment
     * @type {string}
     * @memberof AvailableAssignment
     */
    'overdueDate'?: string;
    /**
     * Optional time limit in minutes for the challenge once started
     * @type {number}
     * @memberof AvailableAssignment
     */
    'timeLimit'?: number;
    /**
     * The identifier of the assignment associated with this challenge
     * @type {string}
     * @memberof AvailableAssignment
     */
    'assignmentId': string;
    /**
     * Minutes already invested in an ongoing attempt. Present only when an ongoing challenge exists.
     * @type {number}
     * @memberof AvailableAssignment
     */
    'workTime'?: number;
    /**
     * Optional cover image URL passed through from the task.
     * @type {string}
     * @memberof AvailableAssignment
     */
    'coverImageUrl'?: string;
    /**
     * Starting-dialog content the partner set on the assignment\'s cohort, shown in the detail drawer before starting.
     * @type {string}
     * @memberof AvailableAssignment
     */
    'challengeDisclaimer'?: string;
    /**
     * Submit-message markdown resolved from the assignment at challenge start; shown on the completed page after submitting.
     * @type {string}
     * @memberof AvailableAssignment
     */
    'submitDisclaimer'?: string;
}


/**
 * 
 * @export
 * @interface AvailableChallenge
 */
export interface AvailableChallenge {
    /**
     * The unique identifier for the challenge
     * @type {string}
     * @memberof AvailableChallenge
     */
    'challengeId'?: string;
    /**
     * Slug representing the challenge
     * @type {string}
     * @memberof AvailableChallenge
     */
    'slug': string;
    /**
     * The unique identifier for the task
     * @type {string}
     * @memberof AvailableChallenge
     */
    'taskId': string;
    /**
     * URL-friendly identifier from the task
     * @type {string}
     * @memberof AvailableChallenge
     */
    'taskSlug'?: string;
    /**
     * The name of the challenge
     * @type {string}
     * @memberof AvailableChallenge
     */
    'name': string;
    /**
     * The description of the challenge
     * @type {string}
     * @memberof AvailableChallenge
     */
    'description'?: string;
    /**
     * 
     * @type {Array<TaskWeaponsOfChoiceEnum>}
     * @memberof AvailableChallenge
     */
    'allowedWeapons': Array<TaskWeaponsOfChoiceEnum>;
    /**
     * 
     * @type {ChallengeDifficultyEnum}
     * @memberof AvailableChallenge
     */
    'difficulty': ChallengeDifficultyEnum;
    /**
     * 
     * @type {AvailableChallengeStatusEnum}
     * @memberof AvailableChallenge
     */
    'status': AvailableChallengeStatusEnum;
    /**
     * The remaining time in minutes until the challenge is available again
     * @type {number}
     * @memberof AvailableChallenge
     */
    'cooldownRemainingTime'?: number;
    /**
     * The teaser of the challenge
     * @type {string}
     * @memberof AvailableChallenge
     */
    'teaser': string;
    /**
     * Proficiencies required for this task
     * @type {Array<string>}
     * @memberof AvailableChallenge
     */
    'proficiencies'?: Array<string>;
    /**
     * The identifier of the assignment associated with this challenge
     * @type {string}
     * @memberof AvailableChallenge
     */
    'assignmentId'?: string;
    /**
     * 
     * @type {TimeCategoryEnum}
     * @memberof AvailableChallenge
     */
    'timeCategory': TimeCategoryEnum;
    /**
     * Minutes already invested in an ongoing attempt. Present only when an ongoing challenge exists.
     * @type {number}
     * @memberof AvailableChallenge
     */
    'workTime'?: number;
    /**
     * Optional cover image URL passed through from the task.
     * @type {string}
     * @memberof AvailableChallenge
     */
    'coverImageUrl'?: string;
    /**
     * Vertical focal point (0-100) for the cover image, passed through from the task. Used as the CSS object-position Y.
     * @type {number}
     * @memberof AvailableChallenge
     */
    'coverFocusY'?: number;
    /**
     * 
     * @type {TaskWeaponsOfChoiceEnum}
     * @memberof AvailableChallenge
     */
    'weaponOfChoice'?: TaskWeaponsOfChoiceEnum;
    /**
     * True when the underlying task is a sandbox task.
     * @type {boolean}
     * @memberof AvailableChallenge
     */
    'isSandbox'?: boolean;
}


/**
 * The status of an available challenge
 * @export
 * @enum {string}
 */

export const AvailableChallengeStatusEnum = {
    Available: 'available',
    Unbooted: 'unbooted',
    Ongoing: 'ongoing',
    Cooldown: 'cooldown',
    Aborted: 'aborted',
    Finished: 'finished'
} as const;

export type AvailableChallengeStatusEnum = typeof AvailableChallengeStatusEnum[keyof typeof AvailableChallengeStatusEnum];


/**
 * 
 * @export
 * @interface BootEnvironmentRequest
 */
export interface BootEnvironmentRequest {
    /**
     * The task identifier for the challenge
     * @type {string}
     * @memberof BootEnvironmentRequest
     */
    'taskId': string;
    /**
     * The assignment identifier for the challenge
     * @type {string}
     * @memberof BootEnvironmentRequest
     */
    'assignmentId'?: string;
    /**
     * 
     * @type {TaskWeaponsOfChoiceEnum}
     * @memberof BootEnvironmentRequest
     */
    'chosenWeapon'?: TaskWeaponsOfChoiceEnum;
}


/**
 * 
 * @export
 * @interface BootEnvironmentResponse
 */
export interface BootEnvironmentResponse {
    /**
     * Whether the environment boot was successful
     * @type {boolean}
     * @memberof BootEnvironmentResponse
     */
    'success': boolean;
    /**
     * Slug representing the challenge
     * @type {string}
     * @memberof BootEnvironmentResponse
     */
    'slug': string;
}
/**
 * 
 * @export
 * @interface Challenge
 */
export interface Challenge {
    /**
     * The unique identifier for the challenge session
     * @type {string}
     * @memberof Challenge
     */
    'id': string;
    /**
     * The identifier of the task being attempted
     * @type {string}
     * @memberof Challenge
     */
    'taskId': string;
    /**
     * The identifier of the user attempting the challenge
     * @type {string}
     * @memberof Challenge
     */
    'userId': string;
    /**
     * The date and time when the challenge was started
     * @type {string}
     * @memberof Challenge
     */
    'startTime': string;
    /**
     * The latest date and time when the challenge can be submitted
     * @type {string}
     * @memberof Challenge
     */
    'submittableUntil'?: string;
    /**
     * The amount of time worked on the challenge in minutes
     * @type {number}
     * @memberof Challenge
     */
    'workTime': number;
    /**
     * The date and time when the challenge was completed or aborted
     * @type {string}
     * @memberof Challenge
     */
    'endTime'?: string;
    /**
     * The date and time when the last work time update was reported
     * @type {string}
     * @memberof Challenge
     */
    'lastWorkTimeUpdate'?: string;
    /**
     * 
     * @type {ChallengeStatusEnum}
     * @memberof Challenge
     */
    'status': ChallengeStatusEnum;
    /**
     * 
     * @type {FeedbackStatusEnum}
     * @memberof Challenge
     */
    'feedbackStatus'?: FeedbackStatusEnum;
    /**
     * 
     * @type {WorkState}
     * @memberof Challenge
     */
    'workState'?: WorkState;
    /**
     * Textual feedback provided on the challenge attempt
     * @type {string}
     * @memberof Challenge
     */
    'feedbackText'?: string;
    /**
     * Optional localized learner-facing tips associated with the feedback
     * @type {Array<string>}
     * @memberof Challenge
     */
    'feedbackTips'?: Array<string>;
    /**
     * Optional localized positive learner excerpt associated with the feedback
     * @type {string}
     * @memberof Challenge
     */
    'feedbackExcerpt'?: string;
    /**
     * Numerical grade or score for the challenge attempt
     * @type {number}
     * @memberof Challenge
     */
    'feedbackGrade'?: number;
    /**
     * 
     * @type {EmployerFeedback}
     * @memberof Challenge
     */
    'employerFeedback'?: EmployerFeedback;
    /**
     * Slug representing the challenge
     * @type {string}
     * @memberof Challenge
     */
    'slug': string;
    /**
     * 
     * @type {UserFeedback}
     * @memberof Challenge
     */
    'userFeedback'?: UserFeedback;
    /**
     * Whether the challenge has been soft-deleted
     * @type {boolean}
     * @memberof Challenge
     */
    'deleted'?: boolean;
    /**
     * The identifier of the assignment associated with this challenge
     * @type {string}
     * @memberof Challenge
     */
    'assignmentId'?: string;
    /**
     * The identifier of the organization that owns the challenge\'s assignment, when applicable
     * @type {string}
     * @memberof Challenge
     */
    'organizationId'?: string;
    /**
     * Disclaimer text for the challenge, typically from an associated assignment
     * @type {string}
     * @memberof Challenge
     */
    'challengeDisclaimer'?: string;
    /**
     * Submit-message markdown resolved from the assignment at challenge start; shown on the completed page after submitting.
     * @type {string}
     * @memberof Challenge
     */
    'submitDisclaimer'?: string;
    /**
     * Optional name of a shared database to use instead of creating a per-challenge database
     * @type {string}
     * @memberof Challenge
     */
    'sharedDBName'?: string;
    /**
     * Optional custom query timeout in seconds for this challenge; used instead of default when set
     * @type {number}
     * @memberof Challenge
     */
    'customQueryTimeout'?: number;
    /**
     * History of queries executed for this challenge
     * @type {Array<QueryHistoryEntry>}
     * @memberof Challenge
     */
    'queryHistory'?: Array<QueryHistoryEntry>;
    /**
     * Optional manual override flag to control feedback release behavior for this challenge
     * @type {boolean}
     * @memberof Challenge
     */
    'feedbackReleaseOverride'?: boolean;
    /**
     * Copied from the task\'s isSandboxTask at boot. Sandbox challenges cannot be submitted and are excluded from analytics and aggregations.
     * @type {boolean}
     * @memberof Challenge
     */
    'isSandbox'?: boolean;
    /**
     * 
     * @type {FeedbackLanguageEnum}
     * @memberof Challenge
     */
    'feedbackLanguage'?: FeedbackLanguageEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ChallengeDifficultyEnum = {
    Easy: 'Easy',
    Intermediate: 'Intermediate',
    Hard: 'Hard',
    Expert: 'Expert'
} as const;

export type ChallengeDifficultyEnum = typeof ChallengeDifficultyEnum[keyof typeof ChallengeDifficultyEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const ChallengeErrorCode = {
    ChallengeNotFound: 'challengeNotFound',
    BadRequest: 'badRequest',
    InvalidChallengeId: 'invalidChallengeId',
    ChallengeNotOngoing: 'challengeNotOngoing',
    ChallengeInCooldown: 'challengeInCooldown',
    DatabaseCreationFailed: 'databaseCreationFailed',
    DatabasePopulationFailed: 'databasePopulationFailed',
    DatabaseConnectionFailed: 'databaseConnectionFailed',
    TaskNotFound: 'taskNotFound',
    Unauthorized: 'unauthorized',
    LoggedOut: 'loggedOut',
    UnknownError: 'unknownError',
    InvalidAssignment: 'invalidAssignment',
    QueryTimeout: 'queryTimeout',
    DisallowedPatterns: 'disallowedPatterns',
    TimeWindowEnded: 'timeWindowEnded',
    SandboxNotSubmittable: 'sandboxNotSubmittable'
} as const;

export type ChallengeErrorCode = typeof ChallengeErrorCode[keyof typeof ChallengeErrorCode];


/**
 * 
 * @export
 * @interface ChallengeInfo
 */
export interface ChallengeInfo {
    /**
     * 
     * @type {Challenge}
     * @memberof ChallengeInfo
     */
    'challenge': Challenge;
    /**
     * 
     * @type {Task}
     * @memberof ChallengeInfo
     */
    'task': Task;
    /**
     * 
     * @type {ChallengeInfoUser}
     * @memberof ChallengeInfo
     */
    'user'?: ChallengeInfoUser;
}
/**
 * 
 * @export
 * @interface ChallengeInfoUser
 */
export interface ChallengeInfoUser {
    /**
     * 
     * @type {string}
     * @memberof ChallengeInfoUser
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInfoUser
     */
    'fullName': string;
    /**
     * 
     * @type {UserRoleEnum}
     * @memberof ChallengeInfoUser
     */
    'role': UserRoleEnum;
}


/**
 * Filter criteria for listing challenges; each field is an array and matches if the challenge matches any value in the array
 * @export
 * @interface ChallengeListFilter
 */
export interface ChallengeListFilter {
    /**
     * Filter by challenge status (match any)
     * @type {Array<ChallengeStatusEnum>}
     * @memberof ChallengeListFilter
     */
    'status'?: Array<ChallengeStatusEnum>;
    /**
     * Filter by feedback status (match any): no-feedback, unprocessed, processing, processed
     * @type {Array<FeedbackStatusFilterOption>}
     * @memberof ChallengeListFilter
     */
    'feedbackStatus'?: Array<FeedbackStatusFilterOption>;
    /**
     * Filter by user IDs (match any)
     * @type {Array<string>}
     * @memberof ChallengeListFilter
     */
    'userId'?: Array<string>;
    /**
     * Filter by task IDs (match any)
     * @type {Array<string>}
     * @memberof ChallengeListFilter
     */
    'taskId'?: Array<string>;
    /**
     * Filter by assignment IDs (match any)
     * @type {Array<string>}
     * @memberof ChallengeListFilter
     */
    'assignmentIds'?: Array<string>;
    /**
     * Filter by challenge slug (exact match)
     * @type {string}
     * @memberof ChallengeListFilter
     */
    'slug'?: string;
    /**
     * Filter by the weapon the learner chose (workState.chosenWeapon; match any)
     * @type {Array<TaskWeaponsOfChoiceEnum>}
     * @memberof ChallengeListFilter
     */
    'weaponOfChoice'?: Array<TaskWeaponsOfChoiceEnum>;
    /**
     * When true, soft-deleted challenges are included in the results. Admin-only surface (POST /list requires admin).
     * @type {boolean}
     * @memberof ChallengeListFilter
     */
    'includeDeleted'?: boolean;
}
/**
 * Sortable fields for challenges
 * @export
 * @enum {string}
 */

export const ChallengeSortFieldEnum = {
    Id: 'id',
    UserId: 'userId',
    TaskId: 'taskId',
    Status: 'status',
    FeedbackStatus: 'feedbackStatus',
    WorkTime: 'workTime',
    FeedbackGrade: 'feedbackGrade',
    StartTime: 'startTime',
    EndTime: 'endTime',
    LastWorkTimeUpdate: 'lastWorkTimeUpdate',
    FeedbackReleaseOverride: 'feedbackReleaseOverride',
    Slug: 'slug'
} as const;

export type ChallengeSortFieldEnum = typeof ChallengeSortFieldEnum[keyof typeof ChallengeSortFieldEnum];


/**
 * The current status of the challenge session
 * @export
 * @enum {string}
 */

export const ChallengeStatusEnum = {
    Ongoing: 'ongoing',
    Unbooted: 'unbooted',
    Finished: 'finished',
    Aborted: 'aborted'
} as const;

export type ChallengeStatusEnum = typeof ChallengeStatusEnum[keyof typeof ChallengeStatusEnum];


/**
 * 
 * @export
 * @interface ChallengeTipsEntry
 */
export interface ChallengeTipsEntry {
    /**
     * The challenge that produced these tips
     * @type {string}
     * @memberof ChallengeTipsEntry
     */
    'challengeId': string;
    /**
     * The task the challenge was for
     * @type {string}
     * @memberof ChallengeTipsEntry
     */
    'taskId': string;
    /**
     * Feedback tips from this challenge
     * @type {Array<string>}
     * @memberof ChallengeTipsEntry
     */
    'tips': Array<string>;
    /**
     * When the feedback was received
     * @type {string}
     * @memberof ChallengeTipsEntry
     */
    'date': string;
}
/**
 * 
 * @export
 * @interface ChallengesResponse
 */
export interface ChallengesResponse {
    /**
     * The total number of available challenges
     * @type {number}
     * @memberof ChallengesResponse
     */
    'count': number;
    /**
     * Array of available challenges with their details
     * @type {Array<AvailableChallenge>}
     * @memberof ChallengesResponse
     */
    'availableChallenges': Array<AvailableChallenge>;
    /**
     * Array of available assigned challenges with their details
     * @type {Array<AvailableAssignment>}
     * @memberof ChallengesResponse
     */
    'availableAssignments': Array<AvailableAssignment>;
    /**
     * True if the user has completed at least one assignment (used e.g. for Join Gamma CTA)
     * @type {boolean}
     * @memberof ChallengesResponse
     */
    'hasFinishedAssignment'?: boolean;
}
/**
 * 
 * @export
 * @interface Chart
 */
export interface Chart {
    /**
     * The unique identifier for the chart
     * @type {string}
     * @memberof Chart
     */
    'id'?: string;
    /**
     * 
     * @type {ChartTypeEnum}
     * @memberof Chart
     */
    'chartType': ChartTypeEnum;
    /**
     * The x-axis label for the chart (optional)
     * @type {string}
     * @memberof Chart
     */
    'xAxis'?: string;
    /**
     * The y-axis label for the chart (optional)
     * @type {string}
     * @memberof Chart
     */
    'yAxis'?: string;
    /**
     * The SQL query used to generate the chart data
     * @type {string}
     * @memberof Chart
     */
    'query': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof Chart
     */
    'data'?: Array<object>;
    /**
     * Whether to show trend line for scatter charts
     * @type {boolean}
     * @memberof Chart
     */
    'showTrendLine'?: boolean;
}


/**
 * The type of chart for data visualization
 * @export
 * @enum {string}
 */

export const ChartTypeEnum = {
    Table: 'table',
    Line: 'line',
    Bar: 'bar',
    Pie: 'pie',
    Scatter: 'scatter'
} as const;

export type ChartTypeEnum = typeof ChartTypeEnum[keyof typeof ChartTypeEnum];


/**
 * 
 * @export
 * @interface CountResponse
 */
export interface CountResponse {
    /**
     * The count of items
     * @type {number}
     * @memberof CountResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface DeleteChallengeResponse
 */
export interface DeleteChallengeResponse {
    /**
     * Whether the challenge was successfully soft-deleted
     * @type {boolean}
     * @memberof DeleteChallengeResponse
     */
    'success': boolean;
    /**
     * Additional message about the delete operation
     * @type {string}
     * @memberof DeleteChallengeResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface EmployerFeedback
 */
export interface EmployerFeedback {
    /**
     * Feedback provided by the employer
     * @type {string}
     * @memberof EmployerFeedback
     */
    'feedback': string;
    /**
     * Grade provided by the employer
     * @type {number}
     * @memberof EmployerFeedback
     */
    'grade': number;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'error': string;
    /**
     * 
     * @type {ChallengeErrorCode}
     * @memberof ErrorResponse
     */
    'errorCode'?: ChallengeErrorCode;
}


/**
 * Language for feedback; duplicates OrganizationSettingsFeedbackLanguageEnum in partner-service
 * @export
 * @enum {string}
 */

export const FeedbackLanguageEnum = {
    En: 'en',
    He: 'he',
    Es: 'es',
    Fr: 'fr',
    De: 'de'
} as const;

export type FeedbackLanguageEnum = typeof FeedbackLanguageEnum[keyof typeof FeedbackLanguageEnum];


/**
 * The current status of the feedback processing
 * @export
 * @enum {string}
 */

export const FeedbackStatusEnum = {
    Unprocessed: 'unprocessed',
    Processing1: 'processing1',
    Processing2: 'processing2',
    Processing3: 'processing3',
    Processing4: 'processing4',
    Processing5: 'processing5',
    Processing6: 'processing6',
    Processing7: 'processing7',
    Processing8: 'processing8',
    Processing9: 'processing9',
    Processing10: 'processing10',
    Processing11: 'processing11',
    Processing12: 'processing12',
    Processing13: 'processing13',
    Processing14: 'processing14',
    Processing15: 'processing15',
    Processed: 'processed'
} as const;

export type FeedbackStatusEnum = typeof FeedbackStatusEnum[keyof typeof FeedbackStatusEnum];


/**
 * Filter option for feedback status: no-feedback (undefined), unprocessed, processing (processing1..15), processed
 * @export
 * @enum {string}
 */

export const FeedbackStatusFilterOption = {
    NoFeedback: 'no-feedback',
    Unprocessed: 'unprocessed',
    Processing: 'processing',
    Processed: 'processed'
} as const;

export type FeedbackStatusFilterOption = typeof FeedbackStatusFilterOption[keyof typeof FeedbackStatusFilterOption];


/**
 * 
 * @export
 * @interface FetchTableDataRequest
 */
export interface FetchTableDataRequest {
    /**
     * The unique identifier for the challenge
     * @type {string}
     * @memberof FetchTableDataRequest
     */
    'challengeId': string;
    /**
     * Name of the table to fetch (must match a key in the task\'s dataBank)
     * @type {string}
     * @memberof FetchTableDataRequest
     */
    'tableName': string;
    /**
     * Row offset for pagination (0-based). Omit for all rows.
     * @type {number}
     * @memberof FetchTableDataRequest
     */
    'offset'?: number;
    /**
     * Maximum number of rows to return. Omit for all rows.
     * @type {number}
     * @memberof FetchTableDataRequest
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface FetchTableDataResponse
 */
export interface FetchTableDataResponse {
    /**
     * Array of records from the requested table
     * @type {Array<{ [key: string]: RunQueryResponseResultsInnerValue; }>}
     * @memberof FetchTableDataResponse
     */
    'results'?: Array<{ [key: string]: RunQueryResponseResultsInnerValue; }>;
    /**
     * Total number of rows in the table (for pagination progress)
     * @type {number}
     * @memberof FetchTableDataResponse
     */
    'totalRows'?: number;
    /**
     * Whether more rows remain after this chunk
     * @type {boolean}
     * @memberof FetchTableDataResponse
     */
    'hasMore'?: boolean;
    /**
     * Error message if the query failed
     * @type {string}
     * @memberof FetchTableDataResponse
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface GetAllChallengesQueryFiltersParameter
 */
export interface GetAllChallengesQueryFiltersParameter {
    /**
     * 
     * @type {ChallengeStatusEnum}
     * @memberof GetAllChallengesQueryFiltersParameter
     */
    'status'?: ChallengeStatusEnum;
    /**
     * Filter by user ID
     * @type {string}
     * @memberof GetAllChallengesQueryFiltersParameter
     */
    'userId'?: string;
    /**
     * Filter by task ID
     * @type {string}
     * @memberof GetAllChallengesQueryFiltersParameter
     */
    'taskId'?: string;
    /**
     * Filter by assignment IDs
     * @type {Array<string>}
     * @memberof GetAllChallengesQueryFiltersParameter
     */
    'assignmentIds'?: Array<string>;
}


/**
 * 
 * @export
 * @interface GradeHistoryEntry
 */
export interface GradeHistoryEntry {
    /**
     * The challenge this grade is from
     * @type {string}
     * @memberof GradeHistoryEntry
     */
    'challengeId': string;
    /**
     * The task the challenge was for
     * @type {string}
     * @memberof GradeHistoryEntry
     */
    'taskId': string;
    /**
     * The feedback grade
     * @type {number}
     * @memberof GradeHistoryEntry
     */
    'grade': number;
    /**
     * When the grade was received
     * @type {string}
     * @memberof GradeHistoryEntry
     */
    'date': string;
}
/**
 * Request body for listing challenges with filter, sort and pagination
 * @export
 * @interface ListChallengesRequest
 */
export interface ListChallengesRequest {
    /**
     * 
     * @type {ChallengeListFilter}
     * @memberof ListChallengesRequest
     */
    'filter'?: ChallengeListFilter;
    /**
     * 
     * @type {ChallengeSortFieldEnum}
     * @memberof ListChallengesRequest
     */
    'sortField'?: ChallengeSortFieldEnum;
    /**
     * 
     * @type {SortDirectionEnum}
     * @memberof ListChallengesRequest
     */
    'sortDirection'?: SortDirectionEnum;
    /**
     * Maximum number of challenges to return
     * @type {number}
     * @memberof ListChallengesRequest
     */
    'limit'?: number;
    /**
     * Number of challenges to skip before collecting the result set
     * @type {number}
     * @memberof ListChallengesRequest
     */
    'offset'?: number;
}


/**
 * 
 * @export
 * @interface PublicAchievementPayload
 */
export interface PublicAchievementPayload {
    /**
     * 
     * @type {string}
     * @memberof PublicAchievementPayload
     */
    'status': PublicAchievementPayloadStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PublicAchievementPayload
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicAchievementPayload
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicAchievementPayload
     */
    'taskName'?: string;
    /**
     * 
     * @type {number}
     * @memberof PublicAchievementPayload
     */
    'attemptNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof PublicAchievementPayload
     */
    'grade'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicAchievementPayload
     */
    'submittedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PublicAchievementPayload
     */
    'percentile'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicAchievementPayload
     */
    'percentileAvailable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PublicAchievementPayload
     */
    'workTime'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PublicAchievementPayload
     */
    'memberSince'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicAchievementPayload
     */
    'feedbackExcerpt'?: string | null;
    /**
     * The weapon the learner used for this challenge (workState.chosenWeapon, falling back to the task\'s first allowed weapon)
     * @type {TaskWeaponsOfChoiceEnum}
     * @memberof PublicAchievementPayload
     */
    'weaponOfChoice'?: TaskWeaponsOfChoiceEnum | null;
    /**
     * Branding of the org this assignment-linked submission belongs to; null for non-assignment submissions
     * @type {AchievementOrganization}
     * @memberof PublicAchievementPayload
     */
    'organization'?: AchievementOrganization | null;
}

export const PublicAchievementPayloadStatusEnum = {
    Ok: 'ok',
    Hidden: 'hidden',
    NotFound: 'not_found'
} as const;

export type PublicAchievementPayloadStatusEnum = typeof PublicAchievementPayloadStatusEnum[keyof typeof PublicAchievementPayloadStatusEnum];

/**
 * 
 * @export
 * @interface QueryHistoryEntry
 */
export interface QueryHistoryEntry {
    /**
     * The SQL query that was executed
     * @type {string}
     * @memberof QueryHistoryEntry
     */
    'query': string;
    /**
     * Number of rows returned when the query succeeded
     * @type {number}
     * @memberof QueryHistoryEntry
     */
    'resultCount'?: number;
    /**
     * Error code when the query failed (e.g. queryTimeout, disallowedPatterns)
     * @type {string}
     * @memberof QueryHistoryEntry
     */
    'errorCode'?: string;
}
/**
 * 
 * @export
 * @interface RecalculateProgressRequest
 */
export interface RecalculateProgressRequest {
    /**
     * The user ID to recalculate progress for
     * @type {string}
     * @memberof RecalculateProgressRequest
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface RecalculateProgressResponse
 */
export interface RecalculateProgressResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RecalculateProgressResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof RecalculateProgressResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface RecentTipsEntry
 */
export interface RecentTipsEntry {
    /**
     * The challenge that produced these tips
     * @type {string}
     * @memberof RecentTipsEntry
     */
    'challengeId': string;
    /**
     * The task the challenge was for
     * @type {string}
     * @memberof RecentTipsEntry
     */
    'taskId': string;
    /**
     * Display name of the task
     * @type {string}
     * @memberof RecentTipsEntry
     */
    'taskName': string;
    /**
     * Feedback tips from this challenge
     * @type {Array<string>}
     * @memberof RecentTipsEntry
     */
    'tips': Array<string>;
    /**
     * When the feedback was received
     * @type {string}
     * @memberof RecentTipsEntry
     */
    'date': string;
}
/**
 * 
 * @export
 * @interface RecentTipsResponse
 */
export interface RecentTipsResponse {
    /**
     * The last 4 tips entries for the user
     * @type {Array<RecentTipsEntry>}
     * @memberof RecentTipsResponse
     */
    'tips': Array<RecentTipsEntry>;
}
/**
 * 
 * @export
 * @interface ReleaseFeedbackRequest
 */
export interface ReleaseFeedbackRequest {
    /**
     * The unique identifier for the challenge
     * @type {string}
     * @memberof ReleaseFeedbackRequest
     */
    'challengeId': string;
    /**
     * Whether feedback should be released for this challenge
     * @type {boolean}
     * @memberof ReleaseFeedbackRequest
     */
    'release': boolean;
}
/**
 * 
 * @export
 * @interface ReleaseFeedbackResponse
 */
export interface ReleaseFeedbackResponse {
    /**
     * Whether the feedback release override was updated successfully
     * @type {boolean}
     * @memberof ReleaseFeedbackResponse
     */
    'success': boolean;
    /**
     * Optional message about the operation result
     * @type {string}
     * @memberof ReleaseFeedbackResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ReportWorkTimeRequest
 */
export interface ReportWorkTimeRequest {
    /**
     * The unique identifier for the challenge
     * @type {string}
     * @memberof ReportWorkTimeRequest
     */
    'challengeId': string;
}
/**
 * 
 * @export
 * @interface ReportWorkTimeResponse
 */
export interface ReportWorkTimeResponse {
    /**
     * The updated total work time in minutes
     * @type {number}
     * @memberof ReportWorkTimeResponse
     */
    'workTime': number;
}
/**
 * 
 * @export
 * @interface ResubmitChallengeRequest
 */
export interface ResubmitChallengeRequest {
    /**
     * The unique identifier for the challenge to resubmit
     * @type {string}
     * @memberof ResubmitChallengeRequest
     */
    'challengeId': string;
}
/**
 * 
 * @export
 * @interface ResubmitChallengeResponse
 */
export interface ResubmitChallengeResponse {
    /**
     * Whether the challenge was successfully resubmitted
     * @type {boolean}
     * @memberof ResubmitChallengeResponse
     */
    'success': boolean;
    /**
     * Additional message about the resubmit operation
     * @type {string}
     * @memberof ResubmitChallengeResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface RetakeChallengeRequest
 */
export interface RetakeChallengeRequest {
    /**
     * The unique identifier for the challenge to retake
     * @type {string}
     * @memberof RetakeChallengeRequest
     */
    'challengeId': string;
}
/**
 * 
 * @export
 * @interface RetakeChallengeResponse
 */
export interface RetakeChallengeResponse {
    /**
     * Whether the challenge was successfully reset to ongoing status
     * @type {boolean}
     * @memberof RetakeChallengeResponse
     */
    'success': boolean;
    /**
     * Additional message about the retake operation
     * @type {string}
     * @memberof RetakeChallengeResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface RollChallengeResponse
 */
export interface RollChallengeResponse {
    /**
     * A randomly selected task ID from available tasks
     * @type {string}
     * @memberof RollChallengeResponse
     */
    'taskId': string;
    /**
     * The weapons allowed for the rolled task (defaulted to [\'SQL\'] when the task has no explicit weapons)
     * @type {Array<TaskWeaponsOfChoiceEnum>}
     * @memberof RollChallengeResponse
     */
    'allowedWeapons': Array<TaskWeaponsOfChoiceEnum>;
}
/**
 * 
 * @export
 * @interface RunQueryRequest
 */
export interface RunQueryRequest {
    /**
     * The unique identifier for the challenge
     * @type {string}
     * @memberof RunQueryRequest
     */
    'challengeId': string;
    /**
     * The query to execute
     * @type {string}
     * @memberof RunQueryRequest
     */
    'query': string;
}
/**
 * 
 * @export
 * @interface RunQueryResponse
 */
export interface RunQueryResponse {
    /**
     * Array of records with string or number values
     * @type {Array<{ [key: string]: RunQueryResponseResultsInnerValue; }>}
     * @memberof RunQueryResponse
     */
    'results'?: Array<{ [key: string]: RunQueryResponseResultsInnerValue; }>;
    /**
     * SQL Execution Exception
     * @type {string}
     * @memberof RunQueryResponse
     */
    'error'?: string;
    /**
     * SQL Execution Hint
     * @type {string}
     * @memberof RunQueryResponse
     */
    'hint'?: string;
}
/**
 * @type RunQueryResponseResultsInnerValue
 * @export
 */
export type RunQueryResponseResultsInnerValue = number | string;

/**
 * 
 * @export
 * @interface SaveWorkRequest
 */
export interface SaveWorkRequest {
    /**
     * The unique identifier for the challenge
     * @type {string}
     * @memberof SaveWorkRequest
     */
    'challengeId': string;
    /**
     * 
     * @type {WorkState}
     * @memberof SaveWorkRequest
     */
    'workState'?: WorkState;
}
/**
 * 
 * @export
 * @interface SaveWorkResponse
 */
export interface SaveWorkResponse {
    /**
     * Whether the work was saved successfully
     * @type {boolean}
     * @memberof SaveWorkResponse
     */
    'success'?: boolean;
}
/**
 * Sort direction
 * @export
 * @enum {string}
 */

export const SortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SortDirectionEnum = typeof SortDirectionEnum[keyof typeof SortDirectionEnum];


/**
 * 
 * @export
 * @interface SubmitSolutionRequest
 */
export interface SubmitSolutionRequest {
    /**
     * The unique identifier for the challenge
     * @type {string}
     * @memberof SubmitSolutionRequest
     */
    'challengeId': string;
}
/**
 * 
 * @export
 * @interface SubmitSolutionResponse
 */
export interface SubmitSolutionResponse {
    /**
     * Whether the solution was submitted successfully
     * @type {boolean}
     * @memberof SubmitSolutionResponse
     */
    'success': boolean;
    /**
     * Additional message about the submission
     * @type {string}
     * @memberof SubmitSolutionResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface SubmitUserFeedbackRequest
 */
export interface SubmitUserFeedbackRequest {
    /**
     * The unique identifier for the challenge
     * @type {string}
     * @memberof SubmitUserFeedbackRequest
     */
    'challengeId': string;
    /**
     * 
     * @type {UserFeedback}
     * @memberof SubmitUserFeedbackRequest
     */
    'userFeedback': UserFeedback;
}
/**
 * 
 * @export
 * @interface SubmitUserFeedbackResponse
 */
export interface SubmitUserFeedbackResponse {
    /**
     * Whether the feedback submission was successful
     * @type {boolean}
     * @memberof SubmitUserFeedbackResponse
     */
    'success': boolean;
    /**
     * Additional message about the feedback submission
     * @type {string}
     * @memberof SubmitUserFeedbackResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface TableMetadataEntry
 */
export interface TableMetadataEntry {
    /**
     * Table name as defined in the task\'s dataBank
     * @type {string}
     * @memberof TableMetadataEntry
     */
    'name': string;
    /**
     * Number of rows in the table
     * @type {number}
     * @memberof TableMetadataEntry
     */
    'rowCount': number;
    /**
     * Approximate size of the table in bytes
     * @type {number}
     * @memberof TableMetadataEntry
     */
    'sizeBytes': number;
}
/**
 * 
 * @export
 * @interface TableMetadataRequest
 */
export interface TableMetadataRequest {
    /**
     * The unique identifier for the challenge
     * @type {string}
     * @memberof TableMetadataRequest
     */
    'challengeId': string;
}
/**
 * 
 * @export
 * @interface TableMetadataResponse
 */
export interface TableMetadataResponse {
    /**
     * 
     * @type {Array<TableMetadataEntry>}
     * @memberof TableMetadataResponse
     */
    'tables': Array<TableMetadataEntry>;
}
/**
 * 
 * @export
 * @interface Task
 */
export interface Task {
    /**
     * Task name (3-200 characters)
     * @type {string}
     * @memberof Task
     */
    'name': string;
    /**
     * Task body content (10-50000 characters)
     * @type {string}
     * @memberof Task
     */
    'body': string;
    /**
     * Short teaser text for the task (10-200 characters)
     * @type {string}
     * @memberof Task
     */
    'teaser': string;
    /**
     * Owner ID (1-50 characters, alphanumeric with hyphens and underscores)
     * @type {string}
     * @memberof Task
     */
    'ownerId'?: string;
    /**
     * Weapons (tools/languages) the learner is allowed to use for this task
     * @type {Array<TaskWeaponsOfChoiceEnum>}
     * @memberof Task
     */
    'allowedWeapons'?: Array<TaskWeaponsOfChoiceEnum>;
    /**
     * 
     * @type {TaskDifficultyEnum}
     * @memberof Task
     */
    'difficulty': TaskDifficultyEnum;
    /**
     * Task description (20-10000 characters)
     * @type {string}
     * @memberof Task
     */
    'description': string;
    /**
     * Default query for the task (1-2000 characters)
     * @type {string}
     * @memberof Task
     */
    'defaultQuery': string;
    /**
     * Seed factor (0-100)
     * @type {number}
     * @memberof Task
     */
    'seedFactor'?: number;
    /**
     * JSON string containing feedback data for the task (2 characters minimum)
     * @type {string}
     * @memberof Task
     */
    'feedbackPayload'?: string;
    /**
     * JSON string containing data bank information for the task (2 characters minimum)
     * @type {string}
     * @memberof Task
     */
    'dataBank': string;
    /**
     * Access groups (1-10 unique groups, 1-50 characters each)
     * @type {Array<string>}
     * @memberof Task
     */
    'accessGroups': Array<string>;
    /**
     * Task proficiencies
     * @type {Array<TaskProficienciesEnum>}
     * @memberof Task
     */
    'proficiencies'?: Array<TaskProficienciesEnum>;
    /**
     * Solution placeholder for the task
     * @type {string}
     * @memberof Task
     */
    'solutionPlaceholder'?: string;
    /**
     * Availability weight for the task
     * @type {number}
     * @memberof Task
     */
    'availabilityWeight'?: number;
    /**
     * Sandbox task: can be started and worked on indefinitely but never submitted. No grading, no work-time tracking, excluded from challenge analytics.
     * @type {boolean}
     * @memberof Task
     */
    'isSandboxTask'?: boolean;
    /**
     * Whether the task is deleted
     * @type {boolean}
     * @memberof Task
     */
    'deleted'?: boolean;
    /**
     * Optional name of a shared database to use instead of creating a per-challenge database
     * @type {string}
     * @memberof Task
     */
    'sharedDBName'?: string;
    /**
     * Optional custom query timeout in seconds for challenges of this task; used instead of default when set
     * @type {number}
     * @memberof Task
     */
    'customQueryTimeout'?: number;
    /**
     * Human-readable URL-friendly identifier for the task
     * @type {string}
     * @memberof Task
     */
    'slug'?: string;
    /**
     * Optional URL of the task\'s cover image. Absent until authored; UI falls back to a generated cover.
     * @type {string}
     * @memberof Task
     */
    'coverImageUrl'?: string;
    /**
     * Vertical focal point of the cover image as a percentage (0-100), used as the CSS object-position Y so admins control which slice of the cover shows in the clipped area. Defaults to 50 (center).
     * @type {number}
     * @memberof Task
     */
    'coverFocusY'?: number;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'id': string;
    /**
     * Array of CREATE TABLE queries for the task\'s database schema
     * @type {Array<string>}
     * @memberof Task
     */
    'tableQueries'?: Array<string>;
}


/**
 * 
 * @export
 * @interface Task1
 */
export interface Task1 {
    /**
     * Task name (3-200 characters)
     * @type {string}
     * @memberof Task1
     */
    'name': string;
    /**
     * Task body content (10-50000 characters)
     * @type {string}
     * @memberof Task1
     */
    'body': string;
    /**
     * Short teaser text for the task (10-200 characters)
     * @type {string}
     * @memberof Task1
     */
    'teaser': string;
    /**
     * Owner ID (1-50 characters, alphanumeric with hyphens and underscores)
     * @type {string}
     * @memberof Task1
     */
    'ownerId'?: string;
    /**
     * Weapons (tools/languages) the learner is allowed to use for this task
     * @type {Array<TaskWeaponsOfChoiceEnum>}
     * @memberof Task1
     */
    'allowedWeapons'?: Array<TaskWeaponsOfChoiceEnum>;
    /**
     * 
     * @type {TaskDifficultyEnum}
     * @memberof Task1
     */
    'difficulty': TaskDifficultyEnum;
    /**
     * Task description (20-10000 characters)
     * @type {string}
     * @memberof Task1
     */
    'description': string;
    /**
     * Default query for the task (1-2000 characters)
     * @type {string}
     * @memberof Task1
     */
    'defaultQuery': string;
    /**
     * Seed factor (0-100)
     * @type {number}
     * @memberof Task1
     */
    'seedFactor'?: number;
    /**
     * JSON string containing feedback data for the task (2 characters minimum)
     * @type {string}
     * @memberof Task1
     */
    'feedbackPayload'?: string;
    /**
     * JSON string containing data bank information for the task (2 characters minimum)
     * @type {string}
     * @memberof Task1
     */
    'dataBank': string;
    /**
     * Access groups (1-10 unique groups, 1-50 characters each)
     * @type {Array<string>}
     * @memberof Task1
     */
    'accessGroups': Array<string>;
    /**
     * Task proficiencies
     * @type {Array<TaskProficienciesEnum>}
     * @memberof Task1
     */
    'proficiencies'?: Array<TaskProficienciesEnum>;
    /**
     * Solution placeholder for the task
     * @type {string}
     * @memberof Task1
     */
    'solutionPlaceholder'?: string;
    /**
     * Availability weight for the task
     * @type {number}
     * @memberof Task1
     */
    'availabilityWeight'?: number;
    /**
     * Sandbox task: can be started and worked on indefinitely but never submitted. No grading, no work-time tracking, excluded from challenge analytics.
     * @type {boolean}
     * @memberof Task1
     */
    'isSandboxTask'?: boolean;
    /**
     * Whether the task is deleted
     * @type {boolean}
     * @memberof Task1
     */
    'deleted'?: boolean;
    /**
     * Optional name of a shared database to use instead of creating a per-challenge database
     * @type {string}
     * @memberof Task1
     */
    'sharedDBName'?: string;
    /**
     * Optional custom query timeout in seconds for challenges of this task; used instead of default when set
     * @type {number}
     * @memberof Task1
     */
    'customQueryTimeout'?: number;
    /**
     * Human-readable URL-friendly identifier for the task
     * @type {string}
     * @memberof Task1
     */
    'slug'?: string;
    /**
     * Optional URL of the task\'s cover image. Absent until authored; UI falls back to a generated cover.
     * @type {string}
     * @memberof Task1
     */
    'coverImageUrl'?: string;
    /**
     * Vertical focal point of the cover image as a percentage (0-100), used as the CSS object-position Y so admins control which slice of the cover shows in the clipped area. Defaults to 50 (center).
     * @type {number}
     * @memberof Task1
     */
    'coverFocusY'?: number;
    /**
     * 
     * @type {string}
     * @memberof Task1
     */
    'id': string;
}


/**
 * 
 * @export
 * @interface TaskBase
 */
export interface TaskBase {
    /**
     * Task name (3-200 characters)
     * @type {string}
     * @memberof TaskBase
     */
    'name': string;
    /**
     * Task body content (10-50000 characters)
     * @type {string}
     * @memberof TaskBase
     */
    'body': string;
    /**
     * Short teaser text for the task (10-200 characters)
     * @type {string}
     * @memberof TaskBase
     */
    'teaser': string;
    /**
     * Owner ID (1-50 characters, alphanumeric with hyphens and underscores)
     * @type {string}
     * @memberof TaskBase
     */
    'ownerId'?: string;
    /**
     * Weapons (tools/languages) the learner is allowed to use for this task
     * @type {Array<TaskWeaponsOfChoiceEnum>}
     * @memberof TaskBase
     */
    'allowedWeapons'?: Array<TaskWeaponsOfChoiceEnum>;
    /**
     * 
     * @type {TaskDifficultyEnum}
     * @memberof TaskBase
     */
    'difficulty': TaskDifficultyEnum;
    /**
     * Task description (20-10000 characters)
     * @type {string}
     * @memberof TaskBase
     */
    'description': string;
    /**
     * Default query for the task (1-2000 characters)
     * @type {string}
     * @memberof TaskBase
     */
    'defaultQuery': string;
    /**
     * Seed factor (0-100)
     * @type {number}
     * @memberof TaskBase
     */
    'seedFactor'?: number;
    /**
     * JSON string containing feedback data for the task (2 characters minimum)
     * @type {string}
     * @memberof TaskBase
     */
    'feedbackPayload'?: string;
    /**
     * JSON string containing data bank information for the task (2 characters minimum)
     * @type {string}
     * @memberof TaskBase
     */
    'dataBank': string;
    /**
     * Access groups (1-10 unique groups, 1-50 characters each)
     * @type {Array<string>}
     * @memberof TaskBase
     */
    'accessGroups': Array<string>;
    /**
     * Task proficiencies
     * @type {Array<TaskProficienciesEnum>}
     * @memberof TaskBase
     */
    'proficiencies'?: Array<TaskProficienciesEnum>;
    /**
     * Solution placeholder for the task
     * @type {string}
     * @memberof TaskBase
     */
    'solutionPlaceholder'?: string;
    /**
     * Availability weight for the task
     * @type {number}
     * @memberof TaskBase
     */
    'availabilityWeight'?: number;
    /**
     * Sandbox task: can be started and worked on indefinitely but never submitted. No grading, no work-time tracking, excluded from challenge analytics.
     * @type {boolean}
     * @memberof TaskBase
     */
    'isSandboxTask'?: boolean;
    /**
     * Whether the task is deleted
     * @type {boolean}
     * @memberof TaskBase
     */
    'deleted'?: boolean;
    /**
     * Optional name of a shared database to use instead of creating a per-challenge database
     * @type {string}
     * @memberof TaskBase
     */
    'sharedDBName'?: string;
    /**
     * Optional custom query timeout in seconds for challenges of this task; used instead of default when set
     * @type {number}
     * @memberof TaskBase
     */
    'customQueryTimeout'?: number;
    /**
     * Human-readable URL-friendly identifier for the task
     * @type {string}
     * @memberof TaskBase
     */
    'slug'?: string;
    /**
     * Optional URL of the task\'s cover image. Absent until authored; UI falls back to a generated cover.
     * @type {string}
     * @memberof TaskBase
     */
    'coverImageUrl'?: string;
    /**
     * Vertical focal point of the cover image as a percentage (0-100), used as the CSS object-position Y so admins control which slice of the cover shows in the clipped area. Defaults to 50 (center).
     * @type {number}
     * @memberof TaskBase
     */
    'coverFocusY'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TaskDifficultyEnum = {
    Easy: 'Easy',
    Intermediate: 'Intermediate',
    Hard: 'Hard',
    Expert: 'Expert'
} as const;

export type TaskDifficultyEnum = typeof TaskDifficultyEnum[keyof typeof TaskDifficultyEnum];


/**
 * Task proficiencies
 * @export
 * @enum {string}
 */

export const TaskProficienciesEnum = {
    Joins: 'joins',
    DataSanitization: 'dataSanitization',
    AnomalyDetection: 'anomalyDetection',
    TimeSeriesAnalysis: 'timeSeriesAnalysis',
    WindowFunctions: 'windowFunctions',
    Aggregation: 'aggregation'
} as const;

export type TaskProficienciesEnum = typeof TaskProficienciesEnum[keyof typeof TaskProficienciesEnum];


/**
 * 
 * @export
 * @interface TaskTableQueriesExtension
 */
export interface TaskTableQueriesExtension {
    /**
     * Array of CREATE TABLE queries for the task\'s database schema
     * @type {Array<string>}
     * @memberof TaskTableQueriesExtension
     */
    'tableQueries'?: Array<string>;
}
/**
 * A programming environment/tool (\'weapon\') available to a learner for tackling a task
 * @export
 * @enum {string}
 */

export const TaskWeaponsOfChoiceEnum = {
    Sql: 'SQL',
    Python: 'Python'
} as const;

export type TaskWeaponsOfChoiceEnum = typeof TaskWeaponsOfChoiceEnum[keyof typeof TaskWeaponsOfChoiceEnum];


/**
 * Time category for the challenge
 * @export
 * @enum {string}
 */

export const TimeCategoryEnum = {
    New: 'New',
    UpTo30: 'upTo30',
    UpTo60: 'upTo60',
    _60OrMore: '60OrMore'
} as const;

export type TimeCategoryEnum = typeof TimeCategoryEnum[keyof typeof TimeCategoryEnum];


/**
 * 
 * @export
 * @interface UserFeedback
 */
export interface UserFeedback {
    /**
     * Overall rating provided by the user
     * @type {number}
     * @memberof UserFeedback
     */
    'overallRating': number;
    /**
     * Rating indicating they know what to practice next
     * @type {number}
     * @memberof UserFeedback
     */
    'practiceNextRating': number;
    /**
     * Indicates if the user agrees with the feedback received
     * @type {boolean}
     * @memberof UserFeedback
     */
    'agreeWithFeedback': boolean;
    /**
     * Optional reason why the user disagrees with the feedback
     * @type {string}
     * @memberof UserFeedback
     */
    'whyNoAgree'?: string;
    /**
     * Optional additional comments from the user
     * @type {string}
     * @memberof UserFeedback
     */
    'freeText'?: string;
    /**
     * Epoch timestamp representing when the feedback was submitted
     * @type {number}
     * @memberof UserFeedback
     */
    'submissionDate'?: number;
}
/**
 * 
 * @export
 * @interface UserProgress
 */
export interface UserProgress {
    /**
     * The user this progress record belongs to
     * @type {string}
     * @memberof UserProgress
     */
    'userId': string;
    /**
     * Accumulated tips from each submitted challenge
     * @type {Array<ChallengeTipsEntry>}
     * @memberof UserProgress
     */
    'tips'?: Array<ChallengeTipsEntry>;
    /**
     * Grade progression over time
     * @type {Array<GradeHistoryEntry>}
     * @memberof UserProgress
     */
    'gradeHistory'?: Array<GradeHistoryEntry>;
    /**
     * Total number of finished challenges
     * @type {number}
     * @memberof UserProgress
     */
    'totalChallengesCompleted'?: number;
    /**
     * Accumulated work time in minutes
     * @type {number}
     * @memberof UserProgress
     */
    'totalWorkTime'?: number;
    /**
     * Date of most recent challenge completion
     * @type {string}
     * @memberof UserProgress
     */
    'lastActivityDate'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UserRoleEnum = {
    Admin: 'admin',
    User: 'user',
    Partner: 'partner'
} as const;

export type UserRoleEnum = typeof UserRoleEnum[keyof typeof UserRoleEnum];


/**
 * 
 * @export
 * @interface ViewBody
 */
export interface ViewBody {
    /**
     * 
     * @type {string}
     * @memberof ViewBody
     */
    'referrer'?: string | null;
}
/**
 * 
 * @export
 * @interface WorkState
 */
export interface WorkState {
    /**
     * The solution submitted by the user
     * @type {string}
     * @memberof WorkState
     */
    'solution'?: string;
    /**
     * The last query executed by the user
     * @type {string}
     * @memberof WorkState
     */
    'lastQuery'?: string;
    /**
     * Free-form notes for the challenge workspace
     * @type {string}
     * @memberof WorkState
     */
    'notes'?: string;
    /**
     * Object map of charts with chart IDs as keys and chart data as values
     * @type {{ [key: string]: Chart; }}
     * @memberof WorkState
     */
    'charts'?: { [key: string]: Chart; };
    /**
     * Array of tab views, each containing tabs and their state
     * @type {Array<WorkspaceTabView>}
     * @memberof WorkState
     */
    'tabViews'?: Array<WorkspaceTabView>;
    /**
     * Jupyter notebook content in nbformat v4 (INotebookContent). Stored as free-form JSON.
     * @type {{ [key: string]: any; }}
     * @memberof WorkState
     */
    'jNotebook'?: { [key: string]: any; };
    /**
     * 
     * @type {TaskWeaponsOfChoiceEnum}
     * @memberof WorkState
     */
    'chosenWeapon'?: TaskWeaponsOfChoiceEnum;
    /**
     * UTC timestamp (ISO 8601) of when this work state was last persisted. Used by the autosave indicator.
     * @type {string}
     * @memberof WorkState
     */
    'savedAt'?: string;
}


/**
 * 
 * @export
 * @interface WorkspaceTab
 */
export interface WorkspaceTab {
    /**
     * 
     * @type {WorkspaceTabTypeEnum}
     * @memberof WorkspaceTab
     */
    'type': WorkspaceTabTypeEnum;
    /**
     * Optional data associated with the tab
     * @type {string}
     * @memberof WorkspaceTab
     */
    'data'?: string;
}


/**
 * Type of the workspace tab
 * @export
 * @enum {string}
 */

export const WorkspaceTabTypeEnum = {
    Assignment: 'assignment',
    Sql: 'sql',
    Python: 'python',
    Solution: 'solution',
    Notes: 'notes',
    SqlCheatSheet: 'sqlCheatSheet',
    TipsHistory: 'tipsHistory'
} as const;

export type WorkspaceTabTypeEnum = typeof WorkspaceTabTypeEnum[keyof typeof WorkspaceTabTypeEnum];


/**
 * 
 * @export
 * @interface WorkspaceTabView
 */
export interface WorkspaceTabView {
    /**
     * Index of the currently active tab in this view
     * @type {number}
     * @memberof WorkspaceTabView
     */
    'activeTab': number;
    /**
     * Array of tabs in this view
     * @type {Array<WorkspaceTab>}
     * @memberof WorkspaceTabView
     */
    'tabs': Array<WorkspaceTab>;
    /**
     * Optional width percentage for this view (when in split view)
     * @type {number}
     * @memberof WorkspaceTabView
     */
    'width'?: number;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Backfill user active days from existing challenge timestamps (admin)
         * @param {AdminBackfillUserActiveDaysRequest} adminBackfillUserActiveDaysRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBackfillUserActiveDays: async (adminBackfillUserActiveDaysRequest: AdminBackfillUserActiveDaysRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminBackfillUserActiveDaysRequest' is not null or undefined
            assertParamExists('adminBackfillUserActiveDays', 'adminBackfillUserActiveDaysRequest', adminBackfillUserActiveDaysRequest)
            const localVarPath = `/admin/migrations/backfill-user-active-days`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminBackfillUserActiveDaysRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hard delete all challenges for a user (internal)
         * @param {AdminDeleteUserChallengesRequest} adminDeleteUserChallengesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteUserChallenges: async (adminDeleteUserChallengesRequest: AdminDeleteUserChallengesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminDeleteUserChallengesRequest' is not null or undefined
            assertParamExists('adminDeleteUserChallenges', 'adminDeleteUserChallengesRequest', adminDeleteUserChallengesRequest)
            const localVarPath = `/admin/delete-user-challenges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminDeleteUserChallengesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Daily DAU/WAU/MAU series from recorded user active days (internal)
         * @param {AdminActiveUsersSeriesRequest} adminActiveUsersSeriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetActiveUsersSeries: async (adminActiveUsersSeriesRequest: AdminActiveUsersSeriesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminActiveUsersSeriesRequest' is not null or undefined
            assertParamExists('adminGetActiveUsersSeries', 'adminActiveUsersSeriesRequest', adminActiveUsersSeriesRequest)
            const localVarPath = `/admin/active-users-series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminActiveUsersSeriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Migrate a task from dataBank to shared DB (internal)
         * @param {AdminMigrateTaskRequest} adminMigrateTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMigrateTaskToSharedDB: async (adminMigrateTaskRequest: AdminMigrateTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminMigrateTaskRequest' is not null or undefined
            assertParamExists('adminMigrateTaskToSharedDB', 'adminMigrateTaskRequest', adminMigrateTaskRequest)
            const localVarPath = `/admin/migrate-task-to-shared-db`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminMigrateTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Boots the environment for a specific challenge
         * @summary Boot Environment
         * @param {BootEnvironmentRequest} bootEnvironmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bootEnvironment: async (bootEnvironmentRequest: BootEnvironmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bootEnvironmentRequest' is not null or undefined
            assertParamExists('bootEnvironment', 'bootEnvironmentRequest', bootEnvironmentRequest)
            const localVarPath = `/boot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bootEnvironmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-deletes a challenge by setting the deleted flag to true. Admin only.
         * @summary Delete Challenge
         * @param {string} id The unique identifier for the challenge to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChallenge: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteChallenge', 'id', id)
            const localVarPath = `/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all rows from a specific table in the challenge\'s database. Validates the table name against the task\'s dataBank keys.
         * @summary Fetch Table Data
         * @param {FetchTableDataRequest} fetchTableDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTableData: async (fetchTableDataRequest: FetchTableDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchTableDataRequest' is not null or undefined
            assertParamExists('fetchTableData', 'fetchTableDataRequest', fetchTableDataRequest)
            const localVarPath = `/table-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchTableDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} challengeSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchievementAnalytics: async (challengeSlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeSlug' is not null or undefined
            assertParamExists('getAchievementAnalytics', 'challengeSlug', challengeSlug)
            const localVarPath = `/achievement/by-challenge/{challengeSlug}/analytics`
                .replace(`{${"challengeSlug"}}`, encodeURIComponent(String(challengeSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} challengeSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchievementByChallenge: async (challengeSlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeSlug' is not null or undefined
            assertParamExists('getAchievementByChallenge', 'challengeSlug', challengeSlug)
            const localVarPath = `/achievement/by-challenge/{challengeSlug}`
                .replace(`{${"challengeSlug"}}`, encodeURIComponent(String(challengeSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all challenges with optional filtering, sorting and pagination
         * @summary Get all challenges
         * @param {GetAllChallengesQueryFiltersParameter} [queryFilters] Filters to apply when querying challenges
         * @param {ChallengeSortFieldEnum} [sortField] Field to sort challenges by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for challenges
         * @param {number} [limit] Maximum number of challenges to return
         * @param {number} [offset] Number of challenges to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChallenges: async (queryFilters?: GetAllChallengesQueryFiltersParameter, sortField?: ChallengeSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (queryFilters !== undefined) {
                for (const [key, value] of Object.entries(queryFilters)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of all available challenges
         * @summary List all available challenges
         * @param {string} [accessGroups] Admin-only debug override: comma-separated access group names. When provided by an admin, available tasks are filtered by these groups (plus the implicit \&#39;all\&#39; group) instead of the admin\&#39;s unfiltered view. Silently ignored for non-admins.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableChallenges: async (accessGroups?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/available-challenges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessGroups !== undefined) {
                localVarQueryParameter['accessGroups'] = accessGroups;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a specific challenge by its slug
         * @summary Get a challenge by slug
         * @param {string} slug The slug for the challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeBySlug: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getChallengeBySlug', 'slug', slug)
            const localVarPath = `/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the count of challenges filtered by status
         * @summary Get count of challenges by status
         * @param {ChallengeStatusEnum} status Filter by challenge status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeCount: async (status: ChallengeStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getChallengeCount', 'status', status)
            const localVarPath = `/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates and returns a PDF document with the candidate\'s feedback for a given challenge. Requires partner access; verifies the challenge\'s assignment belongs to the partner\'s organization.
         * @summary Download Feedback PDF
         * @param {string} challengeId The unique identifier for the challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbackPdf: async (challengeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeId' is not null or undefined
            assertParamExists('getFeedbackPdf', 'challengeId', challengeId)
            const localVarPath = `/feedback-pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (challengeId !== undefined) {
                localVarQueryParameter['challengeId'] = challengeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all finished challenges for the current user
         * @summary Get finished challenges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFinishedChallenges: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/finished-challenges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all ongoing challenges for the logged-in user with their task details
         * @summary Get ongoing challenges for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOngoingChallenges: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ongoing-challenges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicAchievement: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getPublicAchievement', 'slug', slug)
            const localVarPath = `/submission/by-slug/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the last 4 tips entries for the current user
         * @summary Get recent tips
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentTips: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-progress/recent-tips`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns metadata (name, row count, size) for all tables in the challenge\'s database.
         * @summary Get Table Metadata
         * @param {TableMetadataRequest} tableMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTableMetadata: async (tableMetadataRequest: TableMetadataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tableMetadataRequest' is not null or undefined
            assertParamExists('getTableMetadata', 'tableMetadataRequest', tableMetadataRequest)
            const localVarPath = `/table-metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tableMetadataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the accumulated progress record for the current user
         * @summary Get user progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProgress: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves challenges with a structured filter object plus pagination and sort. Admin only.
         * @summary List challenges with filters
         * @param {ListChallengesRequest} listChallengesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChallenges: async (listChallengesRequest: ListChallengesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listChallengesRequest' is not null or undefined
            assertParamExists('listChallenges', 'listChallengesRequest', listChallengesRequest)
            const localVarPath = `/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listChallengesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin endpoint to recalculate a user\'s progress record from their challenges
         * @summary Recalculate user progress
         * @param {RecalculateProgressRequest} recalculateProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateProgress: async (recalculateProgressRequest: RecalculateProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recalculateProgressRequest' is not null or undefined
            assertParamExists('recalculateProgress', 'recalculateProgressRequest', recalculateProgressRequest)
            const localVarPath = `/recalculate-progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recalculateProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {ViewBody} [viewBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordPublicAchievementView: async (slug: string, viewBody?: ViewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('recordPublicAchievementView', 'slug', slug)
            const localVarPath = `/submission/by-slug/{slug}/view`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(viewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggles manual feedback release override for a specific challenge. Admin only.
         * @summary Release Feedback
         * @param {ReleaseFeedbackRequest} releaseFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseFeedback: async (releaseFeedbackRequest: ReleaseFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseFeedbackRequest' is not null or undefined
            assertParamExists('releaseFeedback', 'releaseFeedbackRequest', releaseFeedbackRequest)
            const localVarPath = `/release-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releaseFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reports work time for a specific challenge
         * @summary Report Work Time
         * @param {ReportWorkTimeRequest} reportWorkTimeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportWorkTime: async (reportWorkTimeRequest: ReportWorkTimeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportWorkTimeRequest' is not null or undefined
            assertParamExists('reportWorkTime', 'reportWorkTimeRequest', reportWorkTimeRequest)
            const localVarPath = `/report-worktime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportWorkTimeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin action: resets a finished challenge back to ongoing, clears endTime, and re-submits the solution to the feedback service. Useful when feedback processing failed or needs to be re-triggered.
         * @summary Resubmit Challenge
         * @param {ResubmitChallengeRequest} resubmitChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubmitChallenge: async (resubmitChallengeRequest: ResubmitChallengeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resubmitChallengeRequest' is not null or undefined
            assertParamExists('resubmitChallenge', 'resubmitChallengeRequest', resubmitChallengeRequest)
            const localVarPath = `/resubmit-challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resubmitChallengeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restores a challenge to ongoing status, resets end date and clears feedback data
         * @summary Retake Challenge
         * @param {RetakeChallengeRequest} retakeChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retakeChallenge: async (retakeChallengeRequest: RetakeChallengeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retakeChallengeRequest' is not null or undefined
            assertParamExists('retakeChallenge', 'retakeChallengeRequest', retakeChallengeRequest)
            const localVarPath = `/retake`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retakeChallengeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a random task ID from existing available tasks
         * @summary Roll a Random Challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rollChallenge: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/roll-challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Executes a query for a specific challenge
         * @summary Run Query
         * @param {RunQueryRequest} runQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runQuery: async (runQueryRequest: RunQueryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runQueryRequest' is not null or undefined
            assertParamExists('runQuery', 'runQueryRequest', runQueryRequest)
            const localVarPath = `/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runQueryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves the current work progress for a challenge
         * @summary Save Work Progress
         * @param {SaveWorkRequest} saveWorkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWork: async (saveWorkRequest: SaveWorkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveWorkRequest' is not null or undefined
            assertParamExists('saveWork', 'saveWorkRequest', saveWorkRequest)
            const localVarPath = `/save-work`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveWorkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submits a solution for a specific challenge
         * @summary Submit Solution
         * @param {SubmitSolutionRequest} submitSolutionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSolution: async (submitSolutionRequest: SubmitSolutionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submitSolutionRequest' is not null or undefined
            assertParamExists('submitSolution', 'submitSolutionRequest', submitSolutionRequest)
            const localVarPath = `/submit-solution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitSolutionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submits user feedback for a completed challenge
         * @summary Submit User Feedback
         * @param {SubmitUserFeedbackRequest} submitUserFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitUserFeedback: async (submitUserFeedbackRequest: SubmitUserFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submitUserFeedbackRequest' is not null or undefined
            assertParamExists('submitUserFeedback', 'submitUserFeedbackRequest', submitUserFeedbackRequest)
            const localVarPath = `/submit-user-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitUserFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} challengeSlug 
         * @param {AchievementSettingsPatch} achievementSettingsPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAchievementByChallenge: async (challengeSlug: string, achievementSettingsPatch: AchievementSettingsPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeSlug' is not null or undefined
            assertParamExists('updateAchievementByChallenge', 'challengeSlug', challengeSlug)
            // verify required parameter 'achievementSettingsPatch' is not null or undefined
            assertParamExists('updateAchievementByChallenge', 'achievementSettingsPatch', achievementSettingsPatch)
            const localVarPath = `/achievement/by-challenge/{challengeSlug}`
                .replace(`{${"challengeSlug"}}`, encodeURIComponent(String(challengeSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(achievementSettingsPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Backfill user active days from existing challenge timestamps (admin)
         * @param {AdminBackfillUserActiveDaysRequest} adminBackfillUserActiveDaysRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBackfillUserActiveDays(adminBackfillUserActiveDaysRequest: AdminBackfillUserActiveDaysRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBackfillUserActiveDaysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBackfillUserActiveDays(adminBackfillUserActiveDaysRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminBackfillUserActiveDays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hard delete all challenges for a user (internal)
         * @param {AdminDeleteUserChallengesRequest} adminDeleteUserChallengesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteUserChallenges(adminDeleteUserChallengesRequest: AdminDeleteUserChallengesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDeleteUserChallengesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteUserChallenges(adminDeleteUserChallengesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminDeleteUserChallenges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Daily DAU/WAU/MAU series from recorded user active days (internal)
         * @param {AdminActiveUsersSeriesRequest} adminActiveUsersSeriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetActiveUsersSeries(adminActiveUsersSeriesRequest: AdminActiveUsersSeriesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminActiveUsersSeriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetActiveUsersSeries(adminActiveUsersSeriesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminGetActiveUsersSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Migrate a task from dataBank to shared DB (internal)
         * @param {AdminMigrateTaskRequest} adminMigrateTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminMigrateTaskToSharedDB(adminMigrateTaskRequest: AdminMigrateTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminMigrateTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminMigrateTaskToSharedDB(adminMigrateTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminMigrateTaskToSharedDB']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Boots the environment for a specific challenge
         * @summary Boot Environment
         * @param {BootEnvironmentRequest} bootEnvironmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bootEnvironment(bootEnvironmentRequest: BootEnvironmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BootEnvironmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bootEnvironment(bootEnvironmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.bootEnvironment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-deletes a challenge by setting the deleted flag to true. Admin only.
         * @summary Delete Challenge
         * @param {string} id The unique identifier for the challenge to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChallenge(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteChallengeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChallenge(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all rows from a specific table in the challenge\'s database. Validates the table name against the task\'s dataBank keys.
         * @summary Fetch Table Data
         * @param {FetchTableDataRequest} fetchTableDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchTableData(fetchTableDataRequest: FetchTableDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchTableDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchTableData(fetchTableDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.fetchTableData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} challengeSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAchievementAnalytics(challengeSlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AchievementAnalytics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAchievementAnalytics(challengeSlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAchievementAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} challengeSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAchievementByChallenge(challengeSlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Achievement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAchievementByChallenge(challengeSlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAchievementByChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all challenges with optional filtering, sorting and pagination
         * @summary Get all challenges
         * @param {GetAllChallengesQueryFiltersParameter} [queryFilters] Filters to apply when querying challenges
         * @param {ChallengeSortFieldEnum} [sortField] Field to sort challenges by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for challenges
         * @param {number} [limit] Maximum number of challenges to return
         * @param {number} [offset] Number of challenges to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllChallenges(queryFilters?: GetAllChallengesQueryFiltersParameter, sortField?: ChallengeSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChallengeInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllChallenges(queryFilters, sortField, sortDirection, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllChallenges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of all available challenges
         * @summary List all available challenges
         * @param {string} [accessGroups] Admin-only debug override: comma-separated access group names. When provided by an admin, available tasks are filtered by these groups (plus the implicit \&#39;all\&#39; group) instead of the admin\&#39;s unfiltered view. Silently ignored for non-admins.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableChallenges(accessGroups?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChallengesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableChallenges(accessGroups, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAvailableChallenges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a specific challenge by its slug
         * @summary Get a challenge by slug
         * @param {string} slug The slug for the challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChallengeBySlug(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChallengeInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChallengeBySlug(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getChallengeBySlug']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the count of challenges filtered by status
         * @summary Get count of challenges by status
         * @param {ChallengeStatusEnum} status Filter by challenge status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChallengeCount(status: ChallengeStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChallengeCount(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getChallengeCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates and returns a PDF document with the candidate\'s feedback for a given challenge. Requires partner access; verifies the challenge\'s assignment belongs to the partner\'s organization.
         * @summary Download Feedback PDF
         * @param {string} challengeId The unique identifier for the challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedbackPdf(challengeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeedbackPdf(challengeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFeedbackPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all finished challenges for the current user
         * @summary Get finished challenges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFinishedChallenges(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChallengeInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFinishedChallenges(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFinishedChallenges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all ongoing challenges for the logged-in user with their task details
         * @summary Get ongoing challenges for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOngoingChallenges(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChallengesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOngoingChallenges(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOngoingChallenges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicAchievement(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicAchievementPayload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicAchievement(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPublicAchievement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the last 4 tips entries for the current user
         * @summary Get recent tips
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentTips(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecentTipsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentTips(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRecentTips']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns metadata (name, row count, size) for all tables in the challenge\'s database.
         * @summary Get Table Metadata
         * @param {TableMetadataRequest} tableMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTableMetadata(tableMetadataRequest: TableMetadataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TableMetadataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTableMetadata(tableMetadataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTableMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the accumulated progress record for the current user
         * @summary Get user progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProgress(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProgress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProgress(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves challenges with a structured filter object plus pagination and sort. Admin only.
         * @summary List challenges with filters
         * @param {ListChallengesRequest} listChallengesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listChallenges(listChallengesRequest: ListChallengesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChallengeInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listChallenges(listChallengesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listChallenges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin endpoint to recalculate a user\'s progress record from their challenges
         * @summary Recalculate user progress
         * @param {RecalculateProgressRequest} recalculateProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recalculateProgress(recalculateProgressRequest: RecalculateProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecalculateProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recalculateProgress(recalculateProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.recalculateProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {ViewBody} [viewBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordPublicAchievementView(slug: string, viewBody?: ViewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordPublicAchievementView(slug, viewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.recordPublicAchievementView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggles manual feedback release override for a specific challenge. Admin only.
         * @summary Release Feedback
         * @param {ReleaseFeedbackRequest} releaseFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseFeedback(releaseFeedbackRequest: ReleaseFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseFeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseFeedback(releaseFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.releaseFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reports work time for a specific challenge
         * @summary Report Work Time
         * @param {ReportWorkTimeRequest} reportWorkTimeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportWorkTime(reportWorkTimeRequest: ReportWorkTimeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportWorkTimeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportWorkTime(reportWorkTimeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reportWorkTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin action: resets a finished challenge back to ongoing, clears endTime, and re-submits the solution to the feedback service. Useful when feedback processing failed or needs to be re-triggered.
         * @summary Resubmit Challenge
         * @param {ResubmitChallengeRequest} resubmitChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resubmitChallenge(resubmitChallengeRequest: ResubmitChallengeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResubmitChallengeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resubmitChallenge(resubmitChallengeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.resubmitChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restores a challenge to ongoing status, resets end date and clears feedback data
         * @summary Retake Challenge
         * @param {RetakeChallengeRequest} retakeChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retakeChallenge(retakeChallengeRequest: RetakeChallengeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetakeChallengeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retakeChallenge(retakeChallengeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.retakeChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a random task ID from existing available tasks
         * @summary Roll a Random Challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rollChallenge(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RollChallengeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rollChallenge(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rollChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Executes a query for a specific challenge
         * @summary Run Query
         * @param {RunQueryRequest} runQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runQuery(runQueryRequest: RunQueryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runQuery(runQueryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.runQuery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Saves the current work progress for a challenge
         * @summary Save Work Progress
         * @param {SaveWorkRequest} saveWorkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWork(saveWorkRequest: SaveWorkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveWorkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWork(saveWorkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.saveWork']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submits a solution for a specific challenge
         * @summary Submit Solution
         * @param {SubmitSolutionRequest} submitSolutionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitSolution(submitSolutionRequest: SubmitSolutionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitSolutionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitSolution(submitSolutionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.submitSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submits user feedback for a completed challenge
         * @summary Submit User Feedback
         * @param {SubmitUserFeedbackRequest} submitUserFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitUserFeedback(submitUserFeedbackRequest: SubmitUserFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitUserFeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitUserFeedback(submitUserFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.submitUserFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} challengeSlug 
         * @param {AchievementSettingsPatch} achievementSettingsPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAchievementByChallenge(challengeSlug: string, achievementSettingsPatch: AchievementSettingsPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Achievement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAchievementByChallenge(challengeSlug, achievementSettingsPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateAchievementByChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Backfill user active days from existing challenge timestamps (admin)
         * @param {AdminBackfillUserActiveDaysRequest} adminBackfillUserActiveDaysRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBackfillUserActiveDays(adminBackfillUserActiveDaysRequest: AdminBackfillUserActiveDaysRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminBackfillUserActiveDaysResponse> {
            return localVarFp.adminBackfillUserActiveDays(adminBackfillUserActiveDaysRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hard delete all challenges for a user (internal)
         * @param {AdminDeleteUserChallengesRequest} adminDeleteUserChallengesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteUserChallenges(adminDeleteUserChallengesRequest: AdminDeleteUserChallengesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeleteUserChallengesResponse> {
            return localVarFp.adminDeleteUserChallenges(adminDeleteUserChallengesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Daily DAU/WAU/MAU series from recorded user active days (internal)
         * @param {AdminActiveUsersSeriesRequest} adminActiveUsersSeriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetActiveUsersSeries(adminActiveUsersSeriesRequest: AdminActiveUsersSeriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminActiveUsersSeriesResponse> {
            return localVarFp.adminGetActiveUsersSeries(adminActiveUsersSeriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Migrate a task from dataBank to shared DB (internal)
         * @param {AdminMigrateTaskRequest} adminMigrateTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMigrateTaskToSharedDB(adminMigrateTaskRequest: AdminMigrateTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminMigrateTaskResponse> {
            return localVarFp.adminMigrateTaskToSharedDB(adminMigrateTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Boots the environment for a specific challenge
         * @summary Boot Environment
         * @param {BootEnvironmentRequest} bootEnvironmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bootEnvironment(bootEnvironmentRequest: BootEnvironmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<BootEnvironmentResponse> {
            return localVarFp.bootEnvironment(bootEnvironmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-deletes a challenge by setting the deleted flag to true. Admin only.
         * @summary Delete Challenge
         * @param {string} id The unique identifier for the challenge to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChallenge(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteChallengeResponse> {
            return localVarFp.deleteChallenge(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all rows from a specific table in the challenge\'s database. Validates the table name against the task\'s dataBank keys.
         * @summary Fetch Table Data
         * @param {FetchTableDataRequest} fetchTableDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTableData(fetchTableDataRequest: FetchTableDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<FetchTableDataResponse> {
            return localVarFp.fetchTableData(fetchTableDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} challengeSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchievementAnalytics(challengeSlug: string, options?: RawAxiosRequestConfig): AxiosPromise<AchievementAnalytics> {
            return localVarFp.getAchievementAnalytics(challengeSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} challengeSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchievementByChallenge(challengeSlug: string, options?: RawAxiosRequestConfig): AxiosPromise<Achievement> {
            return localVarFp.getAchievementByChallenge(challengeSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all challenges with optional filtering, sorting and pagination
         * @summary Get all challenges
         * @param {GetAllChallengesQueryFiltersParameter} [queryFilters] Filters to apply when querying challenges
         * @param {ChallengeSortFieldEnum} [sortField] Field to sort challenges by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for challenges
         * @param {number} [limit] Maximum number of challenges to return
         * @param {number} [offset] Number of challenges to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChallenges(queryFilters?: GetAllChallengesQueryFiltersParameter, sortField?: ChallengeSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChallengeInfo>> {
            return localVarFp.getAllChallenges(queryFilters, sortField, sortDirection, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of all available challenges
         * @summary List all available challenges
         * @param {string} [accessGroups] Admin-only debug override: comma-separated access group names. When provided by an admin, available tasks are filtered by these groups (plus the implicit \&#39;all\&#39; group) instead of the admin\&#39;s unfiltered view. Silently ignored for non-admins.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableChallenges(accessGroups?: string, options?: RawAxiosRequestConfig): AxiosPromise<ChallengesResponse> {
            return localVarFp.getAvailableChallenges(accessGroups, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a specific challenge by its slug
         * @summary Get a challenge by slug
         * @param {string} slug The slug for the challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeBySlug(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<ChallengeInfo> {
            return localVarFp.getChallengeBySlug(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the count of challenges filtered by status
         * @summary Get count of challenges by status
         * @param {ChallengeStatusEnum} status Filter by challenge status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeCount(status: ChallengeStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<CountResponse> {
            return localVarFp.getChallengeCount(status, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates and returns a PDF document with the candidate\'s feedback for a given challenge. Requires partner access; verifies the challenge\'s assignment belongs to the partner\'s organization.
         * @summary Download Feedback PDF
         * @param {string} challengeId The unique identifier for the challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbackPdf(challengeId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getFeedbackPdf(challengeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all finished challenges for the current user
         * @summary Get finished challenges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFinishedChallenges(options?: RawAxiosRequestConfig): AxiosPromise<Array<ChallengeInfo>> {
            return localVarFp.getFinishedChallenges(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all ongoing challenges for the logged-in user with their task details
         * @summary Get ongoing challenges for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOngoingChallenges(options?: RawAxiosRequestConfig): AxiosPromise<ChallengesResponse> {
            return localVarFp.getOngoingChallenges(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicAchievement(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<PublicAchievementPayload> {
            return localVarFp.getPublicAchievement(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the last 4 tips entries for the current user
         * @summary Get recent tips
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentTips(options?: RawAxiosRequestConfig): AxiosPromise<RecentTipsResponse> {
            return localVarFp.getRecentTips(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns metadata (name, row count, size) for all tables in the challenge\'s database.
         * @summary Get Table Metadata
         * @param {TableMetadataRequest} tableMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTableMetadata(tableMetadataRequest: TableMetadataRequest, options?: RawAxiosRequestConfig): AxiosPromise<TableMetadataResponse> {
            return localVarFp.getTableMetadata(tableMetadataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the accumulated progress record for the current user
         * @summary Get user progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProgress(options?: RawAxiosRequestConfig): AxiosPromise<UserProgress> {
            return localVarFp.getUserProgress(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves challenges with a structured filter object plus pagination and sort. Admin only.
         * @summary List challenges with filters
         * @param {ListChallengesRequest} listChallengesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChallenges(listChallengesRequest: ListChallengesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChallengeInfo>> {
            return localVarFp.listChallenges(listChallengesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin endpoint to recalculate a user\'s progress record from their challenges
         * @summary Recalculate user progress
         * @param {RecalculateProgressRequest} recalculateProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateProgress(recalculateProgressRequest: RecalculateProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<RecalculateProgressResponse> {
            return localVarFp.recalculateProgress(recalculateProgressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} slug 
         * @param {ViewBody} [viewBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordPublicAchievementView(slug: string, viewBody?: ViewBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recordPublicAchievementView(slug, viewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggles manual feedback release override for a specific challenge. Admin only.
         * @summary Release Feedback
         * @param {ReleaseFeedbackRequest} releaseFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseFeedback(releaseFeedbackRequest: ReleaseFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseFeedbackResponse> {
            return localVarFp.releaseFeedback(releaseFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reports work time for a specific challenge
         * @summary Report Work Time
         * @param {ReportWorkTimeRequest} reportWorkTimeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportWorkTime(reportWorkTimeRequest: ReportWorkTimeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportWorkTimeResponse> {
            return localVarFp.reportWorkTime(reportWorkTimeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin action: resets a finished challenge back to ongoing, clears endTime, and re-submits the solution to the feedback service. Useful when feedback processing failed or needs to be re-triggered.
         * @summary Resubmit Challenge
         * @param {ResubmitChallengeRequest} resubmitChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubmitChallenge(resubmitChallengeRequest: ResubmitChallengeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResubmitChallengeResponse> {
            return localVarFp.resubmitChallenge(resubmitChallengeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Restores a challenge to ongoing status, resets end date and clears feedback data
         * @summary Retake Challenge
         * @param {RetakeChallengeRequest} retakeChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retakeChallenge(retakeChallengeRequest: RetakeChallengeRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetakeChallengeResponse> {
            return localVarFp.retakeChallenge(retakeChallengeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a random task ID from existing available tasks
         * @summary Roll a Random Challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rollChallenge(options?: RawAxiosRequestConfig): AxiosPromise<RollChallengeResponse> {
            return localVarFp.rollChallenge(options).then((request) => request(axios, basePath));
        },
        /**
         * Executes a query for a specific challenge
         * @summary Run Query
         * @param {RunQueryRequest} runQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runQuery(runQueryRequest: RunQueryRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunQueryResponse> {
            return localVarFp.runQuery(runQueryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Saves the current work progress for a challenge
         * @summary Save Work Progress
         * @param {SaveWorkRequest} saveWorkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWork(saveWorkRequest: SaveWorkRequest, options?: RawAxiosRequestConfig): AxiosPromise<SaveWorkResponse> {
            return localVarFp.saveWork(saveWorkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Submits a solution for a specific challenge
         * @summary Submit Solution
         * @param {SubmitSolutionRequest} submitSolutionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSolution(submitSolutionRequest: SubmitSolutionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmitSolutionResponse> {
            return localVarFp.submitSolution(submitSolutionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Submits user feedback for a completed challenge
         * @summary Submit User Feedback
         * @param {SubmitUserFeedbackRequest} submitUserFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitUserFeedback(submitUserFeedbackRequest: SubmitUserFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmitUserFeedbackResponse> {
            return localVarFp.submitUserFeedback(submitUserFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} challengeSlug 
         * @param {AchievementSettingsPatch} achievementSettingsPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAchievementByChallenge(challengeSlug: string, achievementSettingsPatch: AchievementSettingsPatch, options?: RawAxiosRequestConfig): AxiosPromise<Achievement> {
            return localVarFp.updateAchievementByChallenge(challengeSlug, achievementSettingsPatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Backfill user active days from existing challenge timestamps (admin)
     * @param {AdminBackfillUserActiveDaysRequest} adminBackfillUserActiveDaysRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminBackfillUserActiveDays(adminBackfillUserActiveDaysRequest: AdminBackfillUserActiveDaysRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminBackfillUserActiveDays(adminBackfillUserActiveDaysRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hard delete all challenges for a user (internal)
     * @param {AdminDeleteUserChallengesRequest} adminDeleteUserChallengesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminDeleteUserChallenges(adminDeleteUserChallengesRequest: AdminDeleteUserChallengesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminDeleteUserChallenges(adminDeleteUserChallengesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Daily DAU/WAU/MAU series from recorded user active days (internal)
     * @param {AdminActiveUsersSeriesRequest} adminActiveUsersSeriesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminGetActiveUsersSeries(adminActiveUsersSeriesRequest: AdminActiveUsersSeriesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminGetActiveUsersSeries(adminActiveUsersSeriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Migrate a task from dataBank to shared DB (internal)
     * @param {AdminMigrateTaskRequest} adminMigrateTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminMigrateTaskToSharedDB(adminMigrateTaskRequest: AdminMigrateTaskRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminMigrateTaskToSharedDB(adminMigrateTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Boots the environment for a specific challenge
     * @summary Boot Environment
     * @param {BootEnvironmentRequest} bootEnvironmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bootEnvironment(bootEnvironmentRequest: BootEnvironmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bootEnvironment(bootEnvironmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-deletes a challenge by setting the deleted flag to true. Admin only.
     * @summary Delete Challenge
     * @param {string} id The unique identifier for the challenge to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteChallenge(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteChallenge(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all rows from a specific table in the challenge\'s database. Validates the table name against the task\'s dataBank keys.
     * @summary Fetch Table Data
     * @param {FetchTableDataRequest} fetchTableDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public fetchTableData(fetchTableDataRequest: FetchTableDataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).fetchTableData(fetchTableDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} challengeSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAchievementAnalytics(challengeSlug: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAchievementAnalytics(challengeSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} challengeSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAchievementByChallenge(challengeSlug: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAchievementByChallenge(challengeSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all challenges with optional filtering, sorting and pagination
     * @summary Get all challenges
     * @param {GetAllChallengesQueryFiltersParameter} [queryFilters] Filters to apply when querying challenges
     * @param {ChallengeSortFieldEnum} [sortField] Field to sort challenges by
     * @param {SortDirectionEnum} [sortDirection] Sort direction for challenges
     * @param {number} [limit] Maximum number of challenges to return
     * @param {number} [offset] Number of challenges to skip before starting to collect the result set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllChallenges(queryFilters?: GetAllChallengesQueryFiltersParameter, sortField?: ChallengeSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllChallenges(queryFilters, sortField, sortDirection, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of all available challenges
     * @summary List all available challenges
     * @param {string} [accessGroups] Admin-only debug override: comma-separated access group names. When provided by an admin, available tasks are filtered by these groups (plus the implicit \&#39;all\&#39; group) instead of the admin\&#39;s unfiltered view. Silently ignored for non-admins.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAvailableChallenges(accessGroups?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAvailableChallenges(accessGroups, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a specific challenge by its slug
     * @summary Get a challenge by slug
     * @param {string} slug The slug for the challenge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getChallengeBySlug(slug: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getChallengeBySlug(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the count of challenges filtered by status
     * @summary Get count of challenges by status
     * @param {ChallengeStatusEnum} status Filter by challenge status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getChallengeCount(status: ChallengeStatusEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getChallengeCount(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates and returns a PDF document with the candidate\'s feedback for a given challenge. Requires partner access; verifies the challenge\'s assignment belongs to the partner\'s organization.
     * @summary Download Feedback PDF
     * @param {string} challengeId The unique identifier for the challenge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFeedbackPdf(challengeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFeedbackPdf(challengeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all finished challenges for the current user
     * @summary Get finished challenges
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFinishedChallenges(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFinishedChallenges(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all ongoing challenges for the logged-in user with their task details
     * @summary Get ongoing challenges for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOngoingChallenges(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOngoingChallenges(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPublicAchievement(slug: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPublicAchievement(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the last 4 tips entries for the current user
     * @summary Get recent tips
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRecentTips(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRecentTips(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns metadata (name, row count, size) for all tables in the challenge\'s database.
     * @summary Get Table Metadata
     * @param {TableMetadataRequest} tableMetadataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTableMetadata(tableMetadataRequest: TableMetadataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTableMetadata(tableMetadataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the accumulated progress record for the current user
     * @summary Get user progress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserProgress(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserProgress(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves challenges with a structured filter object plus pagination and sort. Admin only.
     * @summary List challenges with filters
     * @param {ListChallengesRequest} listChallengesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listChallenges(listChallengesRequest: ListChallengesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listChallenges(listChallengesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin endpoint to recalculate a user\'s progress record from their challenges
     * @summary Recalculate user progress
     * @param {RecalculateProgressRequest} recalculateProgressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public recalculateProgress(recalculateProgressRequest: RecalculateProgressRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).recalculateProgress(recalculateProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} slug 
     * @param {ViewBody} [viewBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public recordPublicAchievementView(slug: string, viewBody?: ViewBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).recordPublicAchievementView(slug, viewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggles manual feedback release override for a specific challenge. Admin only.
     * @summary Release Feedback
     * @param {ReleaseFeedbackRequest} releaseFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public releaseFeedback(releaseFeedbackRequest: ReleaseFeedbackRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).releaseFeedback(releaseFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reports work time for a specific challenge
     * @summary Report Work Time
     * @param {ReportWorkTimeRequest} reportWorkTimeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public reportWorkTime(reportWorkTimeRequest: ReportWorkTimeRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reportWorkTime(reportWorkTimeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin action: resets a finished challenge back to ongoing, clears endTime, and re-submits the solution to the feedback service. Useful when feedback processing failed or needs to be re-triggered.
     * @summary Resubmit Challenge
     * @param {ResubmitChallengeRequest} resubmitChallengeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resubmitChallenge(resubmitChallengeRequest: ResubmitChallengeRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resubmitChallenge(resubmitChallengeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restores a challenge to ongoing status, resets end date and clears feedback data
     * @summary Retake Challenge
     * @param {RetakeChallengeRequest} retakeChallengeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public retakeChallenge(retakeChallengeRequest: RetakeChallengeRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).retakeChallenge(retakeChallengeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a random task ID from existing available tasks
     * @summary Roll a Random Challenge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rollChallenge(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rollChallenge(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Executes a query for a specific challenge
     * @summary Run Query
     * @param {RunQueryRequest} runQueryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public runQuery(runQueryRequest: RunQueryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).runQuery(runQueryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Saves the current work progress for a challenge
     * @summary Save Work Progress
     * @param {SaveWorkRequest} saveWorkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveWork(saveWorkRequest: SaveWorkRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveWork(saveWorkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submits a solution for a specific challenge
     * @summary Submit Solution
     * @param {SubmitSolutionRequest} submitSolutionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public submitSolution(submitSolutionRequest: SubmitSolutionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).submitSolution(submitSolutionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submits user feedback for a completed challenge
     * @summary Submit User Feedback
     * @param {SubmitUserFeedbackRequest} submitUserFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public submitUserFeedback(submitUserFeedbackRequest: SubmitUserFeedbackRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).submitUserFeedback(submitUserFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} challengeSlug 
     * @param {AchievementSettingsPatch} achievementSettingsPatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAchievementByChallenge(challengeSlug: string, achievementSettingsPatch: AchievementSettingsPatch, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAchievementByChallenge(challengeSlug, achievementSettingsPatch, options).then((request) => request(this.axios, this.basePath));
    }
}



